import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "text-subtitle-2 text-grey" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalListaResultadoTorneo',
  props: {
    listaData: {},
    nickJugador: {},
    ejercito: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isVisible = ref(true);

const closeModal = () => {
  isVisible.value = false;
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisible).value = $event)),
    persistent: "",
    width: "100%",
    "max-width": "none"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(props.nickJugador), 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.ejercito), 1)
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: closeModal
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (!_ctx.listaData)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    type: "image",
                    "max-height": "500"
                  }))
                : (_openBlock(), _createBlock(_component_v_img, {
                    key: 1,
                    src: _ctx.listaData,
                    alt: "Lista de {{ nickJugador }}",
                    class: "rounded-lg",
                    width: "100%",
                    "aspect-ratio": "1",
                    contain: ""
                  }, null, 8, ["src"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})